import { parseAsPageNumber } from '@shared/utils';
import { parseAsArrayOf, parseAsInteger, parseAsString, useQueryStates } from 'nuqs';

const DEFAULT_PAGE_SIZE = 20;

export default function useSearchByKeywordsParams() {
  return useQueryStates({
    keyword: parseAsString.withDefault(''),
    qbankIds: parseAsArrayOf(parseAsString).withDefault([]),
    status: parseAsArrayOf(parseAsString).withDefault([]),
    fields: parseAsArrayOf(parseAsString).withDefault([]),
    page: parseAsPageNumber.withDefault(0),
    pageSize: parseAsInteger.withDefault(DEFAULT_PAGE_SIZE),
  });
}
